/**
 * True until a message has actually been opened/marked read. Kept dependency-free (no store
 * import) so both the customer store's own hasUnreadMessages getter and page-level composables/
 * components can share it without risking a circular import with the store.
 */
export function isMessageUnread(message) {
  return !message.readAt;
}
